export default __webpack_public_path__ + "static/media/dropdown-arrow.c2768d41.svg";